module.exports = __webpack_public_path__ + "img/gm.fab16c83.svg";